<section id="roi-calculation" class="roi-section">
  <div class="value-analysis-layout">
    <div class="analysis-card">
      <div class="analysis-flow">
        <div class="input-card">
          <h2>{{ 'ROI.INPUT.TITLE' | translate }}</h2>

          <div class="maturity-block">
            <h3>{{ 'ROI.INPUT.MATURITY_TITLE' | translate }}</h3>
            <div class="maturity-scale-labels">
              <span>{{ 'ROI.MATURITY_LOW' | translate }}</span>
              <span>{{ 'ROI.MATURITY_HIGH' | translate }}</span>
            </div>
            <input
              type="range"
              min="0"
              max="100"
              [(ngModel)]="maturityLevel"
              [style.background]="maturitySliderBackground"
              (ngModelChange)="onMaturityChange()" />
            <div class="maturity-endpoints">
              <div>
                <p>{{ 'ROI.INPUT.MATURITY_LOW_LINE_1' | translate }}</p>
                <p>{{ 'ROI.INPUT.MATURITY_LOW_LINE_2' | translate }}</p>
              </div>
              <div>
                <p>{{ 'ROI.INPUT.MATURITY_HIGH_LINE_1' | translate }}</p>
                <p>{{ 'ROI.INPUT.MATURITY_HIGH_LINE_2' | translate }}</p>
              </div>
            </div>
          </div>

          <div class="improvements-block">
            <h3>{{ 'ROI.INPUT.IMPROVEMENTS_TITLE' | translate }}</h3>
            <p>{{ 'ROI.INPUT.IMPROVEMENTS_SUBTITLE' | translate }}</p>

            <div class="improvement-grid">
              <div class="improvement-item">
                <span class="improvement-label">{{ 'ROI.INPUT.PRODUCTIVITY_GAIN' | translate }}</span>
                <div class="percent-input">
                  <input
                    type="number"
                    [ngModel]="displayedProductivityGain"
                    (ngModelChange)="onImprovementChange('productivityGainPercent', $event)" />
                  <span>%</span>
                </div>
              </div>

              <div class="improvement-item">
                <span class="improvement-label">{{ 'ROI.INPUT.REWORK_REDUCTION' | translate }}</span>
                <div class="percent-input">
                  <input
                    type="number"
                    [ngModel]="displayedReworkReduction"
                    (ngModelChange)="onImprovementChange('reworkReductionPercent', $event)" />
                  <span>%</span>
                </div>
              </div>

              <div class="improvement-item">
                <span class="improvement-label">{{ 'ROI.INPUT.COORDINATION_SAVINGS' | translate }}</span>
                <div class="percent-input">
                  <input
                    type="number"
                    [ngModel]="displayedCoordinationSavings"
                    (ngModelChange)="onImprovementChange('coordinationSavingsPercent', $event)" />
                  <span>%</span>
                </div>
              </div>
            </div>
          </div>

          <div class="more-inputs-section">
            <button
              type="button"
              class="more-inputs-toggle"
              (click)="toggleMoreInputs()"
              [attr.aria-expanded]="showMoreInputs"
              aria-controls="more-inputs-grid">
              <span class="toggle-chevron" [class.open]="showMoreInputs" aria-hidden="true">
                <svg viewBox="0 0 12 12" focusable="false" aria-hidden="true">
                  <path d="M2.5 4.25 6 7.75l3.5-3.5" />
                </svg>
              </span>
              <span class="toggle-label">{{ 'ROI.INPUT.MORE_INPUTS' | translate }}</span>
            </button>

            @if (showMoreInputs) {
              <div id="more-inputs-grid" class="more-inputs-grid">
                <div class="number-input-row">
                  <div class="field-copy">
                    <p class="field-title">{{ 'ROI.HOURLY_RATE' | translate }}</p>
                    <p class="field-subtitle">{{ 'ROI.HOURLY_RATE_SUB' | translate }}</p>
                  </div>
                  <div class="input-with-stepper">
                    <div class="stepper-input with-prefix">
                      <span class="prefix">{{ currencySymbol }}</span>
                      <input type="number" [ngModel]="averageHourlyRate" (ngModelChange)="updateField('averageHourlyRate', $event)" />
                      <div class="stepper-controls">
                        <button type="button" class="stepper-btn increment" (click)="increment('averageHourlyRate')" aria-label="Increase hourly rate"></button>
                        <button type="button" class="stepper-btn decrement" (click)="decrement('averageHourlyRate')" aria-label="Decrease hourly rate"></button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="number-input-row">
                  <div class="field-copy">
                    <p class="field-title">{{ 'ROI.TEAM_SIZE' | translate }}</p>
                    <p class="field-subtitle">{{ 'ROI.TEAM_SIZE_SUB' | translate }}</p>
                  </div>
                  <div class="input-with-stepper">
                    <div class="stepper-input">
                      <input type="number" [ngModel]="teamSize" (ngModelChange)="updateField('teamSize', $event)" />
                      <div class="stepper-controls">
                        <button type="button" class="stepper-btn increment" (click)="increment('teamSize')" aria-label="Increase team size"></button>
                        <button type="button" class="stepper-btn decrement" (click)="decrement('teamSize')" aria-label="Decrease team size"></button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="number-input-row">
                  <div class="field-copy">
                    <p class="field-title">{{ 'ROI.PROJECTS_YEAR' | translate }}</p>
                    <p class="field-subtitle">{{ 'ROI.PROJECTS_SUB' | translate }}</p>
                  </div>
                  <div class="input-with-stepper">
                    <div class="stepper-input">
                      <input type="number" [ngModel]="projectsPerYear" (ngModelChange)="updateField('projectsPerYear', $event)" />
                      <div class="stepper-controls">
                        <button type="button" class="stepper-btn increment" (click)="increment('projectsPerYear')" aria-label="Increase projects per year"></button>
                        <button type="button" class="stepper-btn decrement" (click)="decrement('projectsPerYear')" aria-label="Decrease projects per year"></button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="number-input-row">
                  <div class="field-copy">
                    <p class="field-title">{{ 'ROI.LICENSE_COST' | translate }}</p>
                    <p class="field-subtitle">{{ 'ROI.LICENSE_SUB' | translate }}</p>
                  </div>
                  <div class="input-with-stepper">
                    <div class="stepper-input with-prefix">
                      <span class="prefix">{{ currencySymbol }}</span>
                      <input type="number" [ngModel]="averageLicenceCost" (ngModelChange)="updateField('averageLicenceCost', $event)" />
                      <div class="stepper-controls">
                        <button type="button" class="stepper-btn increment" (click)="increment('averageLicenceCost')" aria-label="Increase license cost"></button>
                        <button type="button" class="stepper-btn decrement" (click)="decrement('averageLicenceCost')" aria-label="Decrease license cost"></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>

        <div class="impact-card">
          <div class="impact-heading">
            <h2>{{ 'ROI.IMPACT.HEADING' | translate }}</h2>
            <button type="button" class="impact-info-btn" aria-label="Info">i</button>
          </div>

          <div class="impact-panel">
            <p class="impact-info">{{ 'ROI.IMPACT.INFO' | translate }}</p>

            <div class="kpi-grid">
              <div class="kpi-item">
                <h3>{{ 'ROI.IMPACT.ANNUAL_SAVINGS' | translate }}</h3>
                <p>{{ 'ROI.IMPACT.ANNUAL_SAVINGS_DESC' | translate }}</p>
                <strong>{{ currencySymbol }} {{ formatCurrency(roiResults.estimatedAnnualSavings) }}</strong>
              </div>

              <div class="kpi-item">
                <h3>{{ 'ROI.IMPACT.PRODUCTIVITY_GAIN' | translate }}</h3>
                <p>{{ 'ROI.IMPACT.PRODUCTIVITY_GAIN_DESC' | translate }}</p>
                <strong>{{ formatDecimal(roiResults.productivityGain) }}%</strong>
              </div>

              <div class="kpi-item">
                <h3>{{ 'ROI.IMPACT.PAYBACK_PERIOD' | translate }}</h3>
                <p>{{ 'ROI.IMPACT.PAYBACK_PERIOD_DESC' | translate }}</p>
                <strong>
                  @if (roiResults.paybackPeriodMonths >= 1) {
                    {{ formatDecimal(roiResults.paybackPeriodMonths) }} {{ 'ROI.IMPACT.MONTHS' | translate }}
                  } @else if (roiResults.paybackPeriodMonths > 0) {
                    &lt; 1 {{ 'ROI.IMPACT.MONTH' | translate }}
                  } @else {
                    n/a
                  }
                </strong>
              </div>

              <div class="kpi-item">
                <h3>{{ 'ROI.IMPACT.EXTRA_CAPACITY' | translate }}</h3>
                <p>{{ 'ROI.IMPACT.EXTRA_CAPACITY_DESC' | translate }}</p>
                <strong>+ {{ roiResults.extraProjectCapacity }} {{ 'ROI.IMPACT.PROJECTS' | translate }}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
